<template>
  <div>
    <v-app id="login" class="teal">
      <v-content>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex pa-1>
                <div size="30px">
                  <img
                    class="logo-login"
                    src="/static/avatar/logo.png"
                    alt="Avatar"
                  />
                </div>
              </v-flex>
              <v-flex pa-1>
                <v-card-actions class="pb-4">
                  <v-spacer></v-spacer>
                  <h3 class="proceso-titulo">
                    PROCESO {{ new Date().getFullYear() }}
                  </h3>
                </v-card-actions>
              </v-flex>
            </v-flex>
            <v-flex xs12>
              <v-layout align-center justify-center>
                <h2 class="titulo-login">
                  SISTEMA DE INFORMACIÓN DE GESTIÓN ADMINISTRATIVA SIMCE
                </h2>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg5>
            <v-card class="login-card elevation-12">
              <v-card-text>
                <div class="layout column align-center">
                  <h1 class="flex my-4 primary--text titulo">Acceso SIGAS</h1>
                </div>
              </v-card-text>
              <v-card-actions>
                <div class="container">
                  <div class="row"></div>
                </div>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-content>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";

axios.defaults.headers.get["header-name"] = "value";

export default {
  name: "clave-unica",
  data() {
    return {
      // lists: mydata,
      users: [],
    };
  },
  mounted() {
    let uri = window.location;
    // console.log("uriiiiiiiiiiiiiiiii::" + uri);
    let tmp = uri.pathname.split("=");
    let ticket = "";
    if (tmp.length == 2) {
      ticket = tmp[1];
    }
    // console.log("ticketttttttttt::" + ticket);
    this.body = {
      ticket: this.ticket,
    };

    axios
      .post("/validatoken/ticket/" + ticket, this.body)
      // .then(() => this.$router.push("/contratos/proveedores"))
      .then((response) => {
        if (response && response != null && response.data) {
          console.log("Respuesta del servidor:", response.data); //
          this.$store
            .dispatch("loginExterno", { response })
            .then(() => {
              // Navega a la pagina "ProveedorImpresion" despues de la autenticacion exitosa
              this.$router
                .push({ name: "ProveedorImpresion" })
                .catch((err1) => {
                  console.log("catch loginCU load:" + err1);
                });
            })
            .catch((err) => {
              // Maneja errores de autenticacion
              console.log(
                "error loginCU catch dispatch google:" +
                  JSON.stringify(err.message, null, 2)
              );
            });
        } else {
          //no existe usuario en BD???
          window.getApp.$emit("APP_UNAUTHORIZED");
          this.$router.push({ name: "LoginNew" }).catch((err1) => {
            console.log("catch loginCU user no existe?:" + err1);
          });
        }
      })
      .catch((error) => {
        if (error) {
          console.log(error.response.data);
        }
      });
    /*
axios
  .get('https://validadorclaveunica.agenciaeducacion.cl/rest/validarticket?id='+ticket)
  .then(response => response.json())
  .then(json => console.log(json))
  .catch(error => console.log(error))
*/
  },
};
</script>
